import React, {Component} from 'react';
import styles from "../DatiSpecifici.module.css";
import Calendar from "../../../../../components/calendar/Calendar";
import Icon from "../../../../../components/icon/Icon"
import Button from "../../../../../components/button/Button"
import Utils from "../../../../../utils/Utils";
import MalattieService from "../../../../../services/MalattieService";
import OggettiUtili from "../../../../../utils/OggettiUtili"
import {withTranslation} from "react-i18next";
import Select from "../../../../../components/select/Select"
import SelectAutocomplete from "../../../../../components/selectAutocomplete/SelectAutocomplete";
import SessioneUtente from "../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../utils/Ruoli";

class FarmacoResistenza extends Component {
    state = {
        farmacoResistenza: {

            resistenze: this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia)? "3*" : "",
            listaFarmaci: [{
                farmaco: "",
                livelloResistenza: ""
            }],

            dataEsameLaboratorio: "",
            listaDatiBiologici: [{
                tipoConferma: "",
                enzima: "",
                gene: ""
            }],
            corretto: false
        },

        listaResistenza: OggettiUtili.resistenza,
        listaFarmaco: [],
        listaGeni: [],
        listaLivelloResistenza: [],
        listaEnzimi: [],
        listaConferma: OggettiUtili.tipoConferma,
        clicksFarmaci: 0,
        clicksConferme: 0,
        boxesFarmaci: [],
        boxesConferme: [],
    }

    constructor(props) {
        super(props);

        this.onClickAggiungiFarmaco = this.onClickAggiungiFarmaco.bind(this)
        this.onClickAggiungiConferma = this.onClickAggiungiConferma.bind(this)
        this.handleChangeResistenza = this.handleChangeResistenza.bind(this);
        this.handleChangeFarmaco = this.handleChangeFarmaco.bind(this);
        this.handleChangeLivelloResistenza = this.handleChangeLivelloResistenza.bind(this);
        this.handleChangeTipoConferma = this.handleChangeTipoConferma.bind(this);
        this.handleChangeEnzima = this.handleChangeEnzima.bind(this);
        this.handleChangeGene = this.handleChangeGene.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.aggiungiConferma = this.aggiungiConferma.bind(this);
        this.aggiungiResistenza = this.aggiungiResistenza.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.validate = this.validate.bind(this);
        this.loadGene = this.loadGene.bind(this);
        this.settaDisabilitaConferma = this.settaDisabilitaConferma.bind(this);
        this.uniqueObjectFarmaco = this.uniqueObjectFarmaco.bind(this)

    }

    componentDidMount() {
        MalattieService.getFarmacoresistenza(this.props.malattia).then((data) => {
            this.props.showSpinner(true)
            let listaFarmaco = Utils.mapToArray(data.data);
            MalattieService.getLivelloResistenze(this.props.malattia).then((data) => {
                let listaLivelloResistenza = Utils.mapToArray(data.data);
                this.setState({listaLivelloResistenza: listaLivelloResistenza, listaFarmaco: listaFarmaco})
                this.props.showSpinner(false)
                let farmaco = this.state.farmacoResistenza
                let farmacoCopia = JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza)) ? JSON.parse(JSON.stringify(this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza)) : this.state.farmacoResistenza
                farmaco.resistenze = farmacoCopia.resistenze ? farmacoCopia.resistenze : this.state.farmacoResistenza.resistenze
                farmaco.dataEsameLaboratorio = farmacoCopia.dataEsameLaboratorio ? farmacoCopia.dataEsameLaboratorio : this.state.farmacoResistenza.dataEsameLaboratorio
                farmaco.corretto = false;
                if (this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza &&
                    this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza.listaFarmaci) {
                    if (farmacoCopia.listaFarmaci || farmacoCopia.listaFarmaci != null || farmacoCopia.listaFarmaci != undefined) {
                        for (let i = 0; i < farmacoCopia.listaFarmaci.length; i++) {
                            farmaco.listaFarmaci[i] = farmacoCopia.listaFarmaci[i] ? farmacoCopia.listaFarmaci[i] : this.state.farmacoResistenza.listaFarmaci
                            farmaco.listaFarmaci[i].livelloResistenza = farmacoCopia.listaFarmaci[i].livelloResistenza ? farmacoCopia.listaFarmaci[i].livelloResistenza : this.state.farmacoResistenza.listaFarmaci[i].livelloResistenza
                            farmaco.listaFarmaci[i].farmaco = farmacoCopia.listaFarmaci[i].farmaco ? farmacoCopia.listaFarmaci[i].farmaco : this.state.farmacoResistenza.listaFarmaci[i].farmaco
                        }
                    }
                    this.setState({farmacoResistenza: farmaco})
                    for (let i = 0; i < this.state.farmacoResistenza.listaFarmaci.length; i++) {
                        this.onClickAggiungiFarmaco();
                    }
                    this.controlloDati();

                } else {
                    this.onClickAggiungiFarmaco();
                    this.controlloDati();
                }

            }).catch((reason) => {
                console.log("errore chiamata LivelloResistenze: " + reason)
                this.onClickAggiungiFarmaco();
                this.controlloDati();
            });
        }).catch((reason) => {
            console.log("errore chiamata getFarmacoresistenza: " + reason)
            this.onClickAggiungiFarmaco();
            this.controlloDati();
        });

        if (this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza &&
            this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza.listaDatiBiologici) {
            MalattieService.getEnzimiProdotti(this.props.malattia).then((data) => {
                let listaEnzimi = Utils.mapToArray(data.data);
                let listaGeni = this.state.listaGeni
                for (let i = 0; this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza.listaDatiBiologici.length; i++) {
                    let valueNew = this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza.listaDatiBiologici[i].tipoConferma
                    if (valueNew) {
                        this.props.showSpinner(true)
                        MalattieService.getGeni(this.props.malattia, valueNew).then((data) => {
                            let res = Utils.mapToArray(data.data);
                            listaGeni.splice(i, 1, res)
                            this.setState({listaGeni: listaGeni, listaEnzimi: listaEnzimi})
                            this.props.showSpinner(false)
                            if (this.props.segnalazioneCopia.datiSpecifici && this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza &&
                                this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza.listaDatiBiologici) {
                                let farmaco = this.state.farmacoResistenza
                                let farmacoCopia = this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza ? this.props.segnalazioneCopia.datiSpecifici.farmacoResistenza : this.state.farmacoResistenza
                                if (farmacoCopia.listaDatiBiologici || farmacoCopia.listaDatiBiologici != null || farmacoCopia.listaDatiBiologici != undefined) {
                                    for (let i = 0; i < farmacoCopia.listaDatiBiologici.length; i++) {
                                        farmaco.listaDatiBiologici[i] = farmacoCopia.listaDatiBiologici[i] ? farmacoCopia.listaDatiBiologici[i] : this.state.farmacoResistenza.listaDatiBiologici
                                        farmaco.listaDatiBiologici[i].tipoConferma = farmacoCopia.listaDatiBiologici[i].tipoConferma ? farmacoCopia.listaDatiBiologici[i].tipoConferma : this.state.farmacoResistenza.listaDatiBiologici[i].tipoConferma
                                        farmaco.listaDatiBiologici[i].enzima = farmacoCopia.listaDatiBiologici[i].enzima ? farmacoCopia.listaDatiBiologici[i].enzima : this.state.farmacoResistenza.listaDatiBiologici[i].enzima
                                        farmaco.listaDatiBiologici[i].gene = farmacoCopia.listaDatiBiologici[i].gene ? farmacoCopia.listaDatiBiologici[i].gene : this.state.farmacoResistenza.listaDatiBiologici[i].gene
                                        this.loadGene(farmaco.listaDatiBiologici[i].tipoConferma, i)
                                    }
                                }
                                this.setState({farmacoResistenza: farmaco})

                                if (this.state.listaGeni.length > 0) {
                                    for (let i = 0; i < this.state.listaGeni.length; i++) {
                                        this.onClickAggiungiConferma()
                                    }
                                }
                                this.controlloDati();
                            } else {
                                this.onClickAggiungiConferma()
                            }

                        }).catch((reason) => {
                            console.log("errore chiamata: " + reason)
                            this.controlloDati();
                        });
                    }
                }
            }).catch((reason) => {
                console.log("errore chiamata: " + reason)
                this.controlloDati();
            });
        } else {
            MalattieService.getEnzimiProdotti(this.props.malattia).then((data) => {
                let listaEnzimi = Utils.mapToArray(data.data);
                this.setState({listaEnzimi: listaEnzimi})
                this.onClickAggiungiConferma();
                this.controlloDati();
            })
        }
        this.settaDisabilitaConferma()

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.clicksFarmaci > this.state.clicksFarmaci) {
            this.onClickAggiungiFarmaco()
            this.props.setFarmacoResistenza(this.state.farmacoResistenza, this)
            this.settaDisabilitaConferma()
        }

        if (prevState.clicksConferme > this.state.clicksConferme) {
            this.onClickAggiungiConferma()
            this.props.setFarmacoResistenza(this.state.farmacoResistenza, this)
            this.settaDisabilitaConferma()
        }

        if (prevState !== this.state) {
            this.props.setFarmacoResistenza(this.state.farmacoResistenza, this)
            this.settaDisabilitaConferma()
        }
        this.disabledSelectAutocomplete()

    }

    disabledSelectAutocomplete() {
        let condizione = this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)
        Utils.disabledSelectAutocomplete(condizione)
    }

    settaDisabilitaConferma() {
        let listaConferme = this.state.farmacoResistenza

        let variabile = false
        if (listaConferme.listaDatiBiologici) {
            for (let i = 0; i < listaConferme.listaDatiBiologici.length; i++) {
                if (!listaConferme.listaDatiBiologici[i].tipoConferma || !listaConferme.listaDatiBiologici[i].enzima || !listaConferme.listaDatiBiologici[i].gene) {
                    variabile = true
                    break
                }
            }
        }
        return variabile;

    }

    validate() {
        let validateDataEsameLab = Utils.checkDateInterval(this.state.farmacoResistenza.dataEsameLaboratorio, "31/12/1899");
        let checkTodayDataEsameLab = Utils.checkDateLowerToday(this.state.farmacoResistenza.dataEsameLaboratorio);

        if (validateDataEsameLab) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_BT"]), 1
            )
        } else if (checkTodayDataEsameLab) {
            return (
                this.props.aggiungiToaster(["Messages.ERR_01_01_0F_BU"]), 1
            )

        }
        if (this.state.farmacoResistenza.resistenze === "2" || this.state.farmacoResistenza.resistenze === "3") {
            for (let i = 0; i < this.state.farmacoResistenza.listaFarmaci.length; i++) {
                if (this.state.farmacoResistenza.listaFarmaci[i].farmaco) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_BV"]), 1
                    )
                }
            }

            for (let i = 0; i < this.state.farmacoResistenza.listaFarmaci.length; i++) {
                if (this.state.farmacoResistenza.listaFarmaci[i].livelloResistenza) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_BZ"]), 1
                    )
                }
            }

            for (let i = 0; i < this.state.farmacoResistenza.listaDatiBiologici.length; i++) {
                if (this.state.farmacoResistenza.listaDatiBiologici[i].tipoConferma) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_CC"]), 1
                    )
                }
            }

            for (let i = 0; i < this.state.farmacoResistenza.listaDatiBiologici.length; i++) {
                if (this.state.farmacoResistenza.listaDatiBiologici[i].enzima) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_CD"]), 1
                    )
                }
            }

            for (let i = 0; i < this.state.farmacoResistenza.listaDatiBiologici.length; i++) {
                if (this.state.farmacoResistenza.listaDatiBiologici[i].gene) {
                    return (
                        this.props.aggiungiToaster(
                            ["Messages.ERR_01_01_0F_CE"]), 1
                    )
                }
            }
        }

        if (((this.state.farmacoResistenza.resistenze === "2" || this.state.farmacoResistenza.resistenze === "3") && this.state.farmacoResistenza.dataEsameLaboratorio)) {
            return (
                this.props.aggiungiToaster(
                    ["Messages.ERR_01_01_0F_CA"]), 1
            )
        }


        let listaFarmaci = JSON.parse(JSON.stringify(this.state.farmacoResistenza.listaFarmaci))
        let listaBiologici = JSON.parse(JSON.stringify(this.state.farmacoResistenza.listaDatiBiologici))

        let arraylistaFarmaciPulito = Utils.removeEmptyValueFromObject(listaFarmaci)
        let arraylistaBiologiciPulito = Utils.removeEmptyValueFromObject(listaBiologici)


        let ObjectForBackEnd = {}
        let farmacoResistenzaNew = Object.assign({}, this.uniqueObjectFarmaco(arraylistaFarmaciPulito, arraylistaBiologiciPulito))
        let farmacoResistenzaObj = Utils.removeFieldFromObject(farmacoResistenzaNew, "corretto");
        ObjectForBackEnd["resistenze"] = farmacoResistenzaObj.resistenze
        ObjectForBackEnd["listaFarmaci"] = Utils.removeEmptyValueFromObject(farmacoResistenzaObj.listaFarmaci)
        ObjectForBackEnd["dataEsameLaboratorio"] = farmacoResistenzaObj.dataEsameLaboratorio
        ObjectForBackEnd["listaDatiBiologici"] = Utils.removeEmptyValueFromObject(farmacoResistenzaObj.listaDatiBiologici)

        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);

        this.props.setFarmacoResistenza(this.state.farmacoResistenza, this, res)

    }

    controlloDati() {

        let farmacoResistenza = this.state.farmacoResistenza
        farmacoResistenza.corretto = []
        let controlloDati = {farmaco: false, livelloResistenza: false, tipoConferma: false}

        if (!this.state.farmacoResistenza.resistenze) {
            farmacoResistenza.corretto[0] = "Campo \"Resistenze\" mancante"
            return this.setState({farmacoResistenza: farmacoResistenza})
        } else {
            farmacoResistenza.corretto = []
        }

        if (this.state.farmacoResistenza.resistenze === "1") {
            for (let i = 0; i < farmacoResistenza.listaFarmaci.length; i++) {
                if (!farmacoResistenza.listaFarmaci[i].farmaco
                    && !controlloDati.farmaco){
                    farmacoResistenza.corretto[1] = "Campo \"Farmaco\" mancante"
                    controlloDati.farmaco = true
                }
                if(!farmacoResistenza.listaFarmaci[i].livelloResistenza
                && !controlloDati.livelloResistenza) {
                    farmacoResistenza.corretto[2] = "Campo \"Livello di resistenza\" mancante"
                    controlloDati.livelloResistenza = true
                }
            }

            if (!farmacoResistenza.dataEsameLaboratorio) {
                farmacoResistenza.corretto[3] = "Campo \"Data esame laboratorio\" mancante"
            }

            for (let i = 0; i < farmacoResistenza.listaDatiBiologici.length; i++) {
                if (!farmacoResistenza.listaDatiBiologici[i].tipoConferma && !controlloDati.tipoConferma) {
                    farmacoResistenza.corretto[4] = "Campo \"Tipo di conferma\" mancante"
                    controlloDati.tipoConferma = true
                }
            }

            if(this.props.malattia === "0413" && farmacoResistenza.resistenze === "1") {
                for (let index = 0; index < farmacoResistenza.listaDatiBiologici.length; index++) {
                    if (farmacoResistenza.listaDatiBiologici[index].gene === "") {
                        farmacoResistenza.corretto[5] = "Campo \"Gene\" mancante"
                    }
                    if (farmacoResistenza.listaDatiBiologici[index].enzima === "") {
                        farmacoResistenza.corretto[6] = "Campo \"Enzima\" mancante"
                    }
                }
            }
        }

        this.setState({farmacoResistenza: farmacoResistenza})
    }

    riceviValore(field) {
        let farmacoResistenza = this.state.farmacoResistenza
        if (field.currentTarget.id.includes("dataEsameLaboratorio")) {
            farmacoResistenza.dataEsameLaboratorio = field.currentTarget.value;
        }
        this.setState({farmacoResistenza: farmacoResistenza});
        this.controlloDati();
    }

    uniqueObjectFarmaco(elFarmaco, elGene) {
        const tmpFarmaco = new Map()
        const tmpGene = new Map()

        let farmaco = JSON.parse(JSON.stringify(this.state.farmacoResistenza))

        const rsFarmaco = elFarmaco.reduce((acc, e) => {
            if (tmpFarmaco.has(e.farmaco) && tmpFarmaco.has(e.livelloResistenza)) {
                if (!tmpFarmaco.get(e.farmaco).includes(e.jobid) && !tmpFarmaco.get(e.livelloResistenza).includes(e.jobid)) {
                    acc.push(e)
                    tmpFarmaco.set(e.farmaco, [...tmpFarmaco.get(e.farmaco), e.jobid])
                    tmpFarmaco.set(e.livelloResistenza, [...tmpFarmaco.get(e.livelloResistenza), e.jobid])
                }
            } else {
                acc.push(e)
                tmpFarmaco.set(e.farmaco, [e.jobid])
                tmpFarmaco.set(e.livelloResistenza, [e.jobid])
            }
            return acc
        }, [])

        const rsGene = elGene.reduce((acc, e) => {
            if (tmpGene.has(e.tipoConferma) && tmpGene.has(e.enzima) && tmpGene.has(e.gene)) {
                if (!tmpGene.get(e.tipoConferma).includes(e.jobid) && !tmpGene.get(e.enzima).includes(e.jobid) && !tmpGene.get(e.gene).includes(e.jobid)) {
                    acc.push(e)
                    tmpGene.set(e.tipoConferma, [...tmpGene.get(e.tipoConferma), e.jobid])
                    tmpGene.set(e.enzima, [...tmpGene.get(e.enzima), e.jobid])
                    tmpGene.set(e.gene, [...tmpGene.get(e.gene), e.jobid])
                }
            } else {
                acc.push(e)
                tmpGene.set(e.tipoConferma, [e.jobid])
                tmpGene.set(e.enzima, [e.jobid])
                tmpGene.set(e.gene, [e.jobid])
            }
            return acc
        }, [])

        farmaco.listaFarmaci = rsFarmaco
        farmaco.listaDatiBiologici = rsGene

        return farmaco
    }


    handleChangeResistenza(event) {
        let farmacoResistenza = this.state.farmacoResistenza
        farmacoResistenza.resistenze = event.target.value;
        if (event.target.value === "2" || event.target.value === "3" || event.target.value === "3*") {
            farmacoResistenza.listaFarmaci = [{
                farmaco: "",
                livelloResistenza: ""
            }];
            farmacoResistenza.dataEsameLaboratorio = "";
            farmacoResistenza.listaDatiBiologici = [{
                tipoConferma: "",
                enzima: "",
                gene: ""
            }];
        }
        let click = this.state.clicksFarmaci - 1
        let clickConferma = this.state.clicksConferme - 1
        this.setState({farmacoResistenza: farmacoResistenza, clicksFarmaci: click, clicksConferme: clickConferma});
        this.controlloDati();
    }


    aggiungiResistenza() {
        let farmacoResistenza = this.state.farmacoResistenza;
        farmacoResistenza.listaFarmaci.push({
            farmaco: "",
            livelloResistenza: ""
        });
        this.setState({farmacoResistenza: farmacoResistenza});
        this.controlloDati();
    }

    aggiungiConferma() {
        let farmacoResistenza = this.state.farmacoResistenza;
        farmacoResistenza.listaDatiBiologici.push({
            tipoConferma: "",
            enzima: "",
            gene: ""
        });
        this.setState({farmacoResistenza: farmacoResistenza});
        this.controlloDati();

    }

    handleChangeFarmaco(event) {
        let farmacoResistenza = this.state.farmacoResistenza
        let click = this.state.clicksFarmaci - 1
        let indice = event.target.id.replace("farmaco", "")
        farmacoResistenza.listaFarmaci[indice].farmaco = event.target.value
        this.setState({farmacoResistenza: farmacoResistenza, clicksFarmaci: click});
        this.controlloDati();

    }

    handleChangeLivelloResistenza(event) {

        let farmacoResistenza = this.state.farmacoResistenza
        let click = this.state.clicksFarmaci - 1
        let indice = event.target.id.replace("livelloResistenza", "")
        farmacoResistenza.listaFarmaci[indice].livelloResistenza = event.target.value
        this.setState({farmacoResistenza: farmacoResistenza, clicksFarmaci: click});
        this.controlloDati();
    }

    loadGene(valueNew, indice) {
        //il tipo va settato a 1 o due ed è in base al tipoConferma
        // la malattia deve essere: " INFEZIONI DA ENTEROBATTERI PRODUTTORI DI CARBAPENEMASI " codice malattia: " d24584 "
        if (valueNew) {
            MalattieService.getGeni(this.props.malattia, valueNew).then((data) => {
                let listaGeni = this.state.listaGeni
                let clicksConferme = this.state.clicksConferme - 1
                let res = Utils.mapToArray(data.data);
                listaGeni.splice(indice, 1, res)
                this.setState({listaGeni: listaGeni, clicksConferme: clicksConferme})
                this.onClickAggiungiConferma();
                this.controlloDati();
            }).catch((reason) => {
                console.log("errore chiamata: " + reason)
                this.controlloDati();
            });
        }
    }

    handleChangeTipoConferma(event) {
        let farmacoResistenza = this.state.farmacoResistenza
        let click = this.state.clicksConferme - 1
        let indice = event.target.id.replace("tipoConferma", "")
        farmacoResistenza.listaDatiBiologici[indice].gene = ""
        farmacoResistenza.listaDatiBiologici[indice].tipoConferma = event.target.value
        this.setState({farmacoResistenza: farmacoResistenza, clicksConferme: click});
        if (event.target.value === "G" || event.target.value === "F") {
            this.loadGene(event.target.value, indice);
        } else {

            let lista = this.state.listaGeni
            lista[indice] = ""
            this.setState({listaGeni: lista})
        }
        this.controlloDati();

    }

    handleChangeEnzima(event) {
        let farmacoResistenza = this.state.farmacoResistenza
        let click = this.state.clicksConferme - 1
        let indice = event.target.id.replace("enzima", "")
        farmacoResistenza.listaDatiBiologici[indice].enzima = event.target.value
        this.setState({farmacoResistenza: farmacoResistenza, clicksConferme: click});
        this.controlloDati();
    }

    handleChangeGene(event) {
        let farmacoResistenza = this.state.farmacoResistenza
        let click = this.state.clicksConferme - 1
        let indice = event.target.id.replace("gene", "")
        farmacoResistenza.listaDatiBiologici[indice].gene = event.target.value
        this.setState({farmacoResistenza: farmacoResistenza, clicksConferme: click});
        this.controlloDati();
    }

    eliminaRowFarmaco(i){
        let farmacoResistenza = this.state.farmacoResistenza;
        let boxesFarmaci = this.state.boxesFarmaci
        let clicksFarmaci = this.state.clicksFarmaci
        farmacoResistenza.listaFarmaci.splice(i,1)
        boxesFarmaci.splice(i,1)
        this.setState({boxesFarmaci: boxesFarmaci, farmacoResistenza: farmacoResistenza});
        if(i===1) clicksFarmaci = clicksFarmaci - 1
        else clicksFarmaci = clicksFarmaci - 2
        this.onClickAggiungiFarmaco(clicksFarmaci)

    }

    onClickAggiungiFarmaco(clicksFarmaci) {
        let clicks = clicksFarmaci ? clicksFarmaci : this.state.clicksFarmaci === this.state.farmacoResistenza.listaFarmaci.length ? this.state.clicksFarmaci : this.state.clicksFarmaci + 1
        let boxesFarmaci = []
        const {t} = this.props;
        for (let i = 0; i < clicks; i++) {
            boxesFarmaci.push(
                <div>
                    <div className={"row"}>
                        <div className={`col-lg-5 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.FarmacoResistenza.farmaco")}{this.state.farmacoResistenza.resistenze === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : <span/>}</p>
                            <SelectAutocomplete
                                value={this.state.farmacoResistenza.listaFarmaci[i].farmaco}
                                onChange={this.handleChangeFarmaco}
                                id={"farmaco".concat(i)}
                                disabled={this.props.segnalazioneCopia.migrazione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                style={{width: "100%"}}
                                functionMap={this.state.listaFarmaco.map((oggetto) => {
                                    return (<option value={oggetto.codiceFarmacoresistenza}>{oggetto.descrizioneFarmacoresistenza}</option>)
                                })}

                            >
                            </SelectAutocomplete>
                        </div>
                        <div className={`col-lg-4 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.FarmacoResistenza.livelloResistenza")}{this.state.farmacoResistenza.resistenze === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : <span/>}</p>
                            <Select
                                value={this.state.farmacoResistenza.listaFarmaci[i].livelloResistenza}
                                id={"livelloResistenza".concat(i)}
                                onChange={this.handleChangeLivelloResistenza}
                                style={{width: "100%"}}
                                functionMap={this.state.listaLivelloResistenza.map((oggetto) => {
                                    return (<option
                                        value={oggetto.codiceLivelloResistenza}>{oggetto.descrizioneLivelloResistenza}</option>)
                                })}
                            >
                            </Select>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}
                             style={{paddingTop: "2.2rem"}}>
                            {i < 1 ?
                                <Button
                                    onClick={() => {
                                        this.aggiungiResistenza();
                                        this.onClickAggiungiFarmaco()
                                    }}
                                    className={styles.testo}
                                    classes="btn mt-2 btnBluOutline mb-1 "
                                    style={{
                                        padding: "5px", border: "none", background: "none", float: "right",
                                        opacity: (this.props.segnalazioneCopia.migrazione || this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "0.5" : ""
                                    }}
                                    text={this.props.t("DatiSpecifici.FarmacoResistenza.aggiungi")}
                                    icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                    disabled={this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                /> :
                                !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                <span id={"eliminaFarmaco"+i}
                                           onClick={()=>
                                               this.eliminaRowFarmaco(i)

                                           }
                                ><Icon id={"it-delete"} style={{fill: "red", marginTop: "3px", cursor: "pointer"}} /></span> : <div></div>
                            }
                        </div>
                    </div>
                </div>
            )

        }
        this.setState({clicksFarmaci: clicks, boxesFarmaci: boxesFarmaci});
        this.controlloDati();

    }

    eliminaRowAggiungiConferma(i){
        let farmacoResistenza = this.state.farmacoResistenza;
        let boxesConferme = this.state.boxesConferme
        let clicksConferme = this.state.clicksConferme
        farmacoResistenza.listaDatiBiologici.splice(i,1)
        boxesConferme.splice(i,1)
        this.setState({boxesConferme: boxesConferme, farmacoResistenza: farmacoResistenza});
        if(i===1) clicksConferme = clicksConferme - 1
        else clicksConferme = clicksConferme - 2
        this.onClickAggiungiConferma(clicksConferme)

    }

    onClickAggiungiConferma(clicksConferme) {
        const {t} = this.props
        let clicks = clicksConferme ? clicksConferme : this.state.clicksConferme === this.state.farmacoResistenza.listaDatiBiologici.length ? this.state.clicksConferme : this.state.clicksConferme + 1
        let boxesConferme = []
        for (let i = 0; i < clicks; i++) {
            boxesConferme.push(
                <div>
                    <div className={"row"}>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello3' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.FarmacoResistenza.tipo")}</p>
                            {this.state.farmacoResistenza.resistenze === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                            <Select
                                value={this.state.farmacoResistenza.listaDatiBiologici[i].tipoConferma}
                                id={"tipoConferma".concat(i)}
                                onChange={this.handleChangeTipoConferma}
                                style={{width: "100%"}}
                                functionMap={this.state.listaConferma.map((oggetto) => {
                                    return (<option value={oggetto.code}>{oggetto.displayName}</option>)
                                })}
                            >
                            </Select>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.FarmacoResistenza.enzima")}
                                {this.props.malattia === "0413" && this.state.farmacoResistenza.resistenze === "1" ? <span className={styles.mandatoryColor}>*</span> : <></>}
                            </p>

                            <Select
                                value={this.state.farmacoResistenza.listaDatiBiologici[i].enzima}
                                id={"enzima".concat(i)}
                                onChange={this.handleChangeEnzima}
                                style={{width: "100%"}}
                                functionMap={this.state.listaEnzimi.map((oggetto) => {
                                    return (<option
                                        value={oggetto.codiceEnzimaProdotto}>{oggetto.descrizioneEnzimaProdotto}</option>)
                                })}
                            >
                            </Select>
                        </div>
                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p className={styles.testo}>{t("DatiSpecifici.FarmacoResistenza.gene")}
                                {this.props.malattia === "0413" && this.state.farmacoResistenza.resistenze === "1" ? <span className={styles.mandatoryColor}>*</span> : <></>}
                            </p>
                            <Select
                                value={this.state.farmacoResistenza.listaDatiBiologici[i].gene}
                                id={"gene".concat(i)}
                                onChange={this.handleChangeGene}
                                style={{width: "100%"}}
                                functionMap={this.state.listaGeni[i] ? this.state.listaGeni[i].map((oggetto) => {
                                    return (<option value={oggetto.codiceGene}>{oggetto.descrizioneGene}</option>)
                                }) : ""}
                            >
                            </Select>
                        </div>
                        <div className="col-lg-3" style={{paddingTop: "2.2rem"}}>
                            {i < 1 ?
                                <Button
                                    onClick={() => {
                                        this.aggiungiConferma();
                                        this.onClickAggiungiConferma()
                                    }}
                                    disabled={this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                        this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}
                                    className={styles.testo}
                                    classes="btn mt-2 btnBluOutline mb-1 "
                                    style={{
                                        padding: "5px", border: "none", background: "none", float: "right",
                                        opacity: (this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                            this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ? "0.5" : "1"
                                    }}
                                    text={this.props.t("DatiSpecifici.FarmacoResistenza.aggiungiConferma")}
                                    icon={<Icon style={{paddingLeft: "4px", fill: "#0073e6"}} id="it-plus-circle"/>}
                                /> :
                                !(this.props.segnalazioneCopia && this.props.segnalazioneCopia.migrazione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)) ?
                                <span id={"eliminaAggiungiConferma"+i}
                                           onClick={()=>
                                               this.eliminaRowAggiungiConferma(i)

                                           }
                                ><Icon id={"it-delete"} style={{fill: "red", marginTop: "3px", cursor: "pointer"}} /></span> : <div></div>
                            }
                        </div>
                    </div>
                </div>
            )

        }
        this.setState({clicksConferme: clicks, boxesConferme: boxesConferme});

    }

    render() {
        const {t} = this.props

        const section1 = (

            <div style={{marginTop: "1rem"}}>
                <h6>Farmacoresistenza</h6>
                <hr className={styles.hr}></hr>
                <div className={"container"}>

                    <div className="row" style={{paddingTop: "10px"}}>
                        <div className="col-lg-4">
                            <p className={styles.testo}>{t("DatiSpecifici.FarmacoResistenza.resistenze")}<span
                                className={styles.mandatoryColor}>*</span></p>
                            <Select
                                value={this.state.farmacoResistenza.resistenze === "3*"? "3" : this.state.farmacoResistenza.resistenze}
                                onChange={this.handleChangeResistenza}
                                style={{width: "100%"}}
                                functionMap={this.state.listaResistenza.map((oggetto) => {
                                    return (<option value={oggetto.code} style={{backgroundColor:'white'}}>{oggetto.displayName}</option>)
                                })}
                                addclass={!this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati && this.props.malattiePremal.includes(this.props.segnalazioneCopia.malattia) && this.state.farmacoResistenza.resistenze === "3*"? 'select-yellow' : !this.props.segnalazioneCopia.stepConfermati.datiSpecificiConfermati? 'select-white' : ''}
                            >
                            </Select>
                        </div>
                    </div>
                    {this.state.boxesFarmaci}
                </div>
            </div>

        );


        const section2 = (

            <div className={"container"}>
                <div className={"row"} style={{marginTop: "10px"}}>
                    <div className="col-lg-3">
                        <p className={styles.testo}>{t("DatiSpecifici.FarmacoResistenza.dataEsame")}{this.state.farmacoResistenza.resistenze == "1" ?
                            <span className={styles.mandatoryColor}>*</span> : <span/>}</p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className="col-lg-3">
                        <Calendar id={"dataEsameLaboratorio"}
                                  value={this.state.farmacoResistenza.dataEsameLaboratorio}
                                  field={"dataEsameLaboratorio"}
                                  onChange={this.riceviValore}
                                  errorMessage={this.state.farmacoResistenza.dataEsameLaboratorio && Utils.isDateInValid(this.state.farmacoResistenza.dataEsameLaboratorio) ? "Data non valida" : ""}
                                  error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.farmacoResistenza.dataEsameLaboratorio), "-") &&
                                  this.state.farmacoResistenza.dataEsameLaboratorio !== ""}
                        >
                        </Calendar>
                    </div>
                </div>
                {this.state.boxesConferme}
            </div>

        );

        return (
            <div>
                {section1}
                {section2}
            </div>
        );

    }

}

export default withTranslation('common')(FarmacoResistenza)
